import { Icon } from "@iconify/react";
import {
    Box,
    Button,
    Checkbox,
    Container,
    FormControl,
    FormControlLabel,
    FormHelperText,
    Grid,
    InputAdornment,
    InputLabel,
    MenuItem,
    OutlinedInput,
    Radio,
    RadioGroup,
    Select,
    Switch,
    TextField,
    Tooltip,
    Typography,
    makeStyles,
} from "@material-ui/core";
import CreditCardIcon from "@material-ui/icons/CreditCard";
import axios from "axios";
import { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useFieldArray, useForm } from "react-hook-form";
import NumberFormat from "react-number-format";
import { useHistory } from "react-router-dom";
import isNumeric from "validator/lib/isNumeric";

const useStyles = makeStyles((theme) => ({
    title: {
        fontWeight: 600,
    },
    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        textTransform: "none",
        borderRadius: 0,
        fontSize: "14px",
        backgroundColor: "#d8dbe4",
        "&:hover": {
            backgroundColor: "#f2f3f7",
        },
    },
}));

function ContractBankNumberInput(props) {
    const {inputRef, onChange, ...other} = props;
    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            allowEmptyFormatting
        />
    );
}

function NumberInput(props) {
    const {inputRef, onChange, ...other} = props;
    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            allowEmptyFormatting
            format="#### #### #### #### ####"
            mask="_"
        />
    );
}

function BikInput(props) {
    const {inputRef, onChange, ...other} = props;
    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            allowEmptyFormatting
            format="### ### ###"
            mask="_"
        />
    );
}

function PhoneFormat(value) {
    let phone
    if (value[0] === "7") {
        phone = value.substring(1);
    } else if(value[0] !== "7" && value[1] === "7") {
        phone = value.substring(0, 1) + value.substring(2);
    } else {
        phone = value
    }

    let firstPart, secondPart, thirdPart;
    if(phone && (phone[0] === "7" || phone[0] === "8")) {
        phone = phone.substring(1);
    }
    firstPart = phone.substring(0, 3).padEnd(3, "_")
    secondPart = phone.substring(3, 6).padEnd(3, "_")
    thirdPart = phone.substring(6, 10).padEnd(4, "_")

    return `+7 (${firstPart}) ${secondPart} - ${thirdPart}`
}

function PhoneInput(props) {
    const { inputRef, onChange, ...other } = props;
    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            allowEmptyFormatting
            format={PhoneFormat}
        />
    );
}

const TINKOFF_ACCOUNT = '30232810100000000004';

const getAccountType = (val) => {
    if (!val || val.length === 0) return null;
    if (val === TINKOFF_ACCOUNT) return 'tinkoff';
    if (val.startsWith('40817810')) return 'resident';
    if (val.startsWith('4082')) return 'nonResident';
    if ('40817810'.startsWith(val) || '4082'.startsWith(val) || TINKOFF_ACCOUNT.startsWith(val)) return null;
    return 'invalid';
};

const RefundForm = ({items = [], fio = "", email = "", phone = "", isOnlinePayment = false, custom = false}) => {
    const [countSubmit, setCountSubmit] = useState(0);
    const history = useHistory();
    const isFirstRun = useRef(true);
    const {control, register, handleSubmit, trigger, errors, setValue} = useForm({defaultValues: {customItems: [{name: '', qty: 0, price: 0}]}});
    const classes = useStyles();
    const [patronymicRequired, setPatronymicRequired] = useState(true);
    const [ownerPatronymicRequired, setOwnerPatronymicRequired] = useState(true);
    const [state, setState] = useState({
        onlinePayment: false,
        isOnePerson: true,
        products: {},
        radioValue: 1,
        refundType: 1,
    });
    const [fioState, setFioState] = useState(fio);
    const [emailState, setEmailState] = useState(email);
    const [phoneState, setPhoneState] = useState(phone);
    const [ownerFioState, setOwnerFioState] = useState(fio);
    const [bank, setBank] = useState("");
    const [accountType, setAccountType] = useState(null);
    const [place, setPlace] = useState("");
    const [organization, setOrganiozation] = useState("ООО Гипер");
    const [dateBuy, setDateBuy] = useState(new Date());
    const listOfBank = [
        'Сбербанк',
        'ВТБ',
        'Альфа-Банк',
        'Т-Банк',
        'Открытие',
        'Райффайзен',
        'Другой'
    ]
    const listOfPlace = [
        'Wildberries',
        'Мегамаркет',
        'Я.Маркет',
        'Ozon',
        'Другой'
    ]
    const listOfOrganization = [
        'ООО Гипер',
        'ООО Фирменные решения',
    ]

    const { fields, append } = useFieldArray({
        control,
        name: "customItems"
      });

    const setProduct = (event, item) => {
        if (event.target.checked) {
            setState((prevState) => ({
                ...prevState,
                products: {
                    ...prevState.products,
                    [item.codeItem]: {item: item, amount: 1},
                },
            }));
        } else {
            setState((prevState) => {
                const {
                    products: {[item.codeItem]: removedProduct, ...otherProducts},
                    ...otherFields
                } = prevState;

                return {
                    ...otherFields,
                    products: {...otherProducts},
                };
            });
        }
    };

    const setAmount = (amount, codeItem) => {
        setState((prevState) => {
            const products = prevState.products;
            products[codeItem].amount = amount;

            return {
                ...prevState,
                products,
            };
        });
    };

    const onSubmit = (data, actionType) => {
        const {products, patronymic = false, ...other} = data;
        const requestData = {
            ...state,
            patronymic,
            custom,
            place,
            organization,
            ...other,
        };
        axios
            .post(`${process.env.REACT_APP_API_URL}/api/${actionType}`, requestData, {
                withCredentials: true,
            })
            .then(({data}) => {
                if (data?.success) {
                    history.push("/statement");
                }
            });
    };

    useEffect(() => {
        if (isFirstRun.current) {
            isFirstRun.current = false;
            return;
        }
        trigger("patronymic");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [patronymicRequired]);

    useEffect(() => {
        register("phone", {
            validate: (val) => {
                if (!val) return "Обязательное поле";
                if (val.length < 11) return "Некорректный номер телефона";
            },
        });
        register("number", {
            validate: (val) => {
                if (val) {
                    if (val.length < 20) return "Р/с должен состоять из 20 цифр";
                    if (!isNumeric(val)) return "Р/с номер может содержать только цифры";
                    if (getAccountType(val) === 'invalid') return "Введите корректный номер, расчетный счет начинается на 4081";
                }
            },
        });
        register("bank", {
            required: {value: false, message: "Обязательное поле"},
        });
        if (countSubmit) trigger("bank")

        register("place");

        register("bik", {
            validate: (val) => {
                if (val) {
                    if (val.length < 9) return "БИК код должен состоять из 9 цифр";
                    return isNumeric(val) || "БИК код может содержать только цифры";
                }
            },
        });
    }, []);

    useEffect(() => setFioState(fio), [fio])
    useEffect(() => setEmailState(email), [email])
    useEffect(() => setPhoneState(phone), [phone])
    useEffect(() => setOwnerFioState(fio), [fio])

    console.log('errors', errors)

    return (
        <Container maxWidth="sm" style={{paddingLeft: 0, paddingRight: 0}}>
            <Grid
                container
                justify="center"
                spacing={3}
                style={{marginBottom: "16px"}}
            >
                <Typography variant="h6" className={classes.title}>
                    Заявление
                </Typography>
            </Grid>
            <form className={classes.form} noValidate>
                <Box marginBottom="36px">
                {custom && (
                    <Box>
                    <Box>
                    <Typography className={classes.title} variant="body1" style={{marginBottom: "10px"}}>Информация о заказе:</Typography>
                    <FormControl
                        variant="outlined"
                        size="small"
                        style={{minWidth: "200px", marginBottom: "20px"}}
                    >
                        <InputLabel>Выберите площадку:</InputLabel>
                        <Select
                            id="place"
                            label="Выберите площадку:"
                            value={place}
                            name="place"
                            error={!!errors.place?.message}
                            onChange={(e) => {
                                setPlace(e.target.value);
                                setValue("place", e.target.value);
                                if (countSubmit) trigger("place");
                            }}
                        >
                            {listOfPlace.map((key) => (
                                <MenuItem key={key} value={key}>
                                    {key}
                                </MenuItem>
                            ))}
                        </Select>
                        <FormHelperText error={!!errors.place?.message}>
                            {errors.place?.message}
                        </FormHelperText>
                    </FormControl>
                    {place === "Другой" && (
                            <TextField
                                error={!!errors.anotherPlace?.message}
                                helperText={errors.anotherPlace?.message ? errors.anotherPlace?.message : ""}
                                InputProps={{
                                    inputRef: register({
                                        required: {value: bank === "Другой" || false, message: "Обязательное поле"},
                                    })
                                }}
                                size="small"
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                name="anotherPlace"
                                label="Название площадки:"
                                type="text"
                                id="anotherPlace"
                                style={{marginBottom: "16px", marginTop: 0}}
                            />
                            )}
                            </Box>
                            <Box>
                            <FormControl
                        variant="outlined"
                        size="small"
                        style={{minWidth: "200px", marginBottom: "20px"}}
                    >
                        <InputLabel>Выберите организацию:</InputLabel>
                        <Select
                            id="organization"
                            label="Выберите организацию:"
                            value={organization}
                            name="organization"
                            error={!!errors.organization?.message}
                            onChange={(e) => {
                                setOrganiozation(e.target.value);
                                setValue("organization", e.target.value);
                                if (countSubmit) trigger("organization");
                            }}
                        >
                            {listOfOrganization.map((key) => (
                                <MenuItem key={key} value={key}>
                                    {key}
                                </MenuItem>
                            ))}
                        </Select>
                        <FormHelperText error={!!errors.organization?.message}>
                            {errors.organization?.message}
                        </FormHelperText>
                    </FormControl>
                    </Box>
                </Box>
                )}
                    <Typography className={classes.title} variant="body1" style={{marginBottom: "10px"}}>Заявитель:</Typography>
                    <Box>
                        <TextField
                            inputRef={register({
                                required: {value: true, message: "Обязательное поле"},
                                validate: (value) => {
                                    let regexp = /[^-А-ЯЁ\s]/gi;
                                    let wordCount = value.trim().split(' ').length;
                                    let reqWord = patronymicRequired ? 3 : 2;
                                    if(value.match(regexp) !== null) {
                                        return "ФИО заявителя содержит цифры или недопустимые символы";
                                    } else if(wordCount < reqWord) {
                                        return "ФИО заявителя должно включать отчетво";
                                    }
                                    return true;
                                }
                            })}
                            error={!!errors.fio?.message}
                            onChange={(e) =>
                                setFioState(e.target.value)
                            }
                            InputProps={{
                                endAdornment:
                                    <InputAdornment position="end">
                                        <Tooltip placement="top-start"
                                                 title={<div style={{fontSize: "12px"}}>Проверьте корректность
                                                     Фамилии/Имени/Отчества.</div>}>
                                            <Icon width="30" height="30" icon="eva:alert-circle-outline"/>
                                        </Tooltip>
                                    </InputAdornment>
                            }}
                            helperText={errors.fio?.message ? errors.fio?.message : ""}
                            size="small"
                            variant="outlined"
                            value={fioState}
                            margin="normal"
                            fullWidth
                            id="fio"
                            label="ФИО заявителя:"
                            name="fio"
                            autoFocus
                            style={{marginBottom: "16px"}}
                        />
                        <TextField
                            inputRef={register({
                                required: {value: true, message: "Обязательное поле"},
                                validate: (value) => {
                                    let regexp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                                    return value.match(regexp) !== null ||
                                        "Почта заявителя недопустима"
                                }
                            })}
                            error={!!errors.email?.message}
                            onChange={(e) =>
                                setEmailState(e.target.value)
                            }
                            InputProps={{
                                endAdornment:
                                    <InputAdornment position="end">
                                        <Tooltip placement="top-start"
                                                 title={<div style={{fontSize: "12px"}}>Проверьте корректность почты.</div>}>
                                            <Icon width="30" height="30" icon="eva:alert-circle-outline"/>
                                        </Tooltip>
                                    </InputAdornment>
                            }}
                            helperText={errors.email?.message ? errors.email?.message : ""}
                            size="small"
                            variant="outlined"
                            value={emailState}
                            margin="normal"
                            fullWidth
                            id="email"
                            label="Почта заявителя:"
                            name="email"
                            autoFocus
                            style={{marginBottom: "16px"}}
                        />
                        <FormControl
                                variant="outlined"
                                fullWidth
                                size="small"
                                style={{marginBottom: "16px"}}
                            >
                                <InputLabel shrink error={!!errors.phone?.message}>
                                    Телефон:
                                </InputLabel>
                                <OutlinedInput
                                    inputComponent={PhoneInput}
                                    onChange={(e) => {
                                        setValue("phone", e.target.value);
                                        setPhoneState(e.target.value);
                                        if (countSubmit) trigger("phone");
                                    }}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <Tooltip placement="top-start" title={<div style={{fontSize: "12px"}}>Проверьте корректность телефона.</div>}>
                                                <Icon width="30" height="30" icon="eva:alert-circle-outline" />
                                            </Tooltip>
                                        </InputAdornment>
                                    }
                                    notched
                                    name="phone"
                                    value={phoneState}
                                    autoComplete="phone"
                                    label="Телефон заявителя:"
                                />
                                <FormHelperText error={!!errors.phone?.message}>
                                    {errors.phone?.message}
                                </FormHelperText>
                        </FormControl>
                        <Box display="flex" alignItems="center" marginBottom="20px">
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        size="small"
                                        onChange={(e) => {
                                            setPatronymicRequired(!patronymicRequired);
                                            setState((prevState) => ({
                                                ...prevState,
                                                patronymic: e.target.checked ? false : "",
                                            }));
                                        }}
                                        name="patronymic"
                                        color="primary"
                                    />
                                }
                                label="нет отчества"
                            />
                            <Tooltip placement="top-start"
                                     title={<div style={{fontSize: "12px"}}>Отчество отсутствует в паспорте и договоре с
                                         банком</div>}>
                                <Icon width="25" height="25" icon="eva:alert-circle-outline"/>
                            </Tooltip>
                        </Box>
                    </Box>
                    <Typography className={classes.title} variant="body1" style={{marginBottom: "10px"}}>Владелец счета:</Typography>
                    <Box>
                        <FormControlLabel
                            style={{marginBottom: "16px"}}
                            control={
                                <Switch
                                    checked={state.isOnePerson}
                                    onChange={() =>
                                        setState((prevState) => ({
                                            ...prevState,
                                            isOnePerson: !prevState.isOnePerson,
                                        }))
                                    }
                                    name="isOnePerson"
                                    color="primary"
                                />
                            }
                            label="Совпадает с Заявителем"
                        />
                        {!state.isOnePerson && (<div>
                            <TextField
                                inputRef={register({
                                    required: {
                                        value: !state.isOnePerson || false,
                                        message: "Обязательное поле"
                                    },
                                    validate: (value) => {
                                        let regexp = /[^-А-ЯЁ\s]/gi;
                                        return value.match(regexp) === null ||
                                            "ФИО владельца счета содержит цифры или недопустимые символы"
                                    },
                                })}
                                onChange={(e) =>
                                    setOwnerFioState(e.target.value)
                                }
                                InputProps={{
                                    endAdornment:
                                        <InputAdornment position="end">
                                            <Tooltip placement="top-start"
                                                     title={<div style={{fontSize: "12px"}}>Проверьте корректность
                                                         Фамилии/Имени/Отчества.</div>}>
                                                <Icon width="30" height="30" icon="eva:alert-circle-outline"/>
                                            </Tooltip>
                                        </InputAdornment>
                                }}
                                error={!!errors.ownerFio?.message}
                                helperText={errors.ownerFio?.message ? errors.ownerFio?.message : ""}
                                size="small"
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                id="ownerFio"
                                label="ФИО владельца счета:"
                                name="ownerFio"
                                value={ownerFioState}
                                autoFocus
                                style={{marginBottom: "16px"}}
                            />
                            <Box display="flex" alignItems="center" marginBottom="20px">
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            size="small"
                                            onChange={(e) => {
                                                setOwnerPatronymicRequired(!ownerPatronymicRequired);
                                                setState((prevState) => ({
                                                    ...prevState,
                                                    ownerPatronymic: e.target.checked ? false : "",
                                                }));
                                            }}
                                            name="ownerPatronymic"
                                            color="primary"
                                        />
                                    }
                                    label="нет отчества"
                                />
                                <Tooltip placement="top-start"
                                         title={<div style={{fontSize: "12px"}}>Отчество отсутствует в паспорте и
                                             договоре с банком</div>}>
                                    <Icon width="25" height="25" icon="eva:alert-circle-outline"/>
                                </Tooltip>
                            </Box>
                        </div>)}
                    </Box>
                    <Typography className={classes.title} variant="body1" style={{marginBottom: "20px"}}>Банковские данные:</Typography>
                    <FormControl
                        variant="outlined"
                        size="small"
                        style={{minWidth: "200px", marginBottom: "20px"}}
                    >
                        <InputLabel>Выберите банк:</InputLabel>
                        <Select
                            id="bank"
                            label="Выберите банк:"
                            value={bank}
                            name="bank"
                            error={!!errors.bank?.message}
                            onChange={(e) => {
                                setBank(e.target.value);
                                setValue("bank", e.target.value);
                                if (countSubmit) trigger("bank");
                            }}
                        >
                            {listOfBank.map((key) => (
                                <MenuItem key={key} value={key}>
                                    {key}
                                </MenuItem>
                            ))}
                        </Select>
                        <FormHelperText error={!!errors.bank?.message}>
                            {errors.bank?.message}
                        </FormHelperText>
                    </FormControl>
                    {!isOnlinePayment && (
                        <div>
                            {(bank === "Т-Банк" || accountType === 'tinkoff') && (
                            <TextField
                                error={!!errors.contractBankNumber?.message}
                                helperText={errors.contractBankNumber?.message ? errors.contractBankNumber?.message : ""}
                                InputProps={{
                                    inputRef: register({
                                        required: {value: bank === "Т-Банк" || accountType === 'tinkoff', message: "Обязательное поле"},
                                    })
                                }}
                                size="small"
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                name="contractBankNumber"
                                label="Номер договора в банке:"
                                type="text"
                                id="contractBankNumber"
                                style={{marginBottom: "16px", marginTop: 0}}
                            />
                            )}

                            {bank === "Другой" && (
                            <TextField
                                error={!!errors.anotherBank?.message}
                                helperText={errors.anotherBank?.message ? errors.anotherBank?.message : ""}
                                InputProps={{
                                    inputRef: register({
                                        required: {value: bank === "Другой" || false, message: "Обязательное поле"},
                                    })
                                }}
                                size="small"
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                name="anotherBank"
                                label="Название банка:"
                                type="text"
                                id="anotherBank"
                                style={{marginBottom: "16px", marginTop: 0}}
                            />
                            )}

                            <FormControl
                                variant="outlined"
                                fullWidth
                                size="small"
                                style={{marginBottom: "16px"}}
                            >
                                <InputLabel shrink error={!!errors.number?.message}>
                                    Расчетный счет в банке:
                                </InputLabel>
                                <OutlinedInput
                                    inputComponent={NumberInput}
                                    onChange={(e) => {
                                        const val = e.target.value;
                                        setValue("number", val);
                                        const type = getAccountType(val);
                                        setAccountType(type);
                                        if (type === 'tinkoff') {
                                            setBank('Т-Банк');
                                            setValue("bank", 'Т-Банк');
                                        }
                                        if (countSubmit) trigger("number");
                                    }}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <Tooltip placement="top-start" title={<div style={{fontSize: "12px"}}>Расчетный счет должен принадлежать владельцу</div>}>
                                                <Icon width="30" height="30" icon="eva:alert-circle-outline" />
                                            </Tooltip>
                                        </InputAdornment>
                                    }
                                    notched
                                    name="number"
                                    autoComplete="number"
                                    label="Расчетный счет в банке:"
                                />
                                <FormHelperText error={!!errors.number?.message}>
                                    {errors.number?.message}
                                </FormHelperText>
                            </FormControl>

                            {accountType === 'invalid' && (
                                <Typography variant="body2" style={{color: '#f44336', marginBottom: '8px'}}>
                                    Введите корректный номер, расчетный счет начинается на 4081
                                </Typography>
                            )}

                            {(accountType === 'nonResident' || accountType === 'tinkoff') && (
                                <div>
                                    {accountType === 'nonResident' && (
                                        <Typography variant="body2" style={{fontWeight: 600, marginBottom: '8px', color: errors.citizenship?.message ? '#f44336' : 'inherit'}}>
                                            Вы вводите счет нерезидента РФ. Укажите гражданство в поле ниже или введите р/с резидента 40817810...
                                        </Typography>
                                    )}
                                    <TextField
                                        error={!!errors.citizenship?.message}
                                        helperText={errors.citizenship?.message || ""}
                                        InputProps={{
                                            inputRef: register({
                                                required: {value: true, message: "Обязательное поле"},
                                            })
                                        }}
                                        size="small"
                                        variant="outlined"
                                        margin="normal"
                                        fullWidth
                                        name="citizenship"
                                        label="Гражданство:"
                                        type="text"
                                        id="citizenship"
                                        style={{marginBottom: "16px", marginTop: 0}}
                                    />
                                </div>
                            )}

                            <FormControl
                                variant="outlined"
                                fullWidth
                                size="small"
                                style={{marginBottom: "16px"}}
                            >
                                <InputLabel shrink error={!!errors.bik?.message}>
                                    БИК номер:
                                </InputLabel>
                                <OutlinedInput
                                    inputComponent={BikInput}
                                    onChange={(e) => {
                                        setValue("bik", e.target.value);
                                        if (countSubmit) trigger("bik");
                                    }}
                                    notched
                                    name="bik"
                                    autoComplete="bik"
                                    label="БИК номер банка:"
                                />
                                <FormHelperText error={!!errors.bik?.message}>
                                    {errors.bik?.message}
                                </FormHelperText>
                            </FormControl>
                        </div>
                    )}
                    {isOnlinePayment && (
                        <TextField
                            error={!!errors.credit?.message}
                            helperText={errors.credit?.message ? errors.credit?.message : ""}
                            placeholder="_ _ _ _"
                            InputProps={{
                                inputRef: register({
                                    required: {value: true, message: "Обязательное поле"},
                                    maxLength: {value: 4, message: "Введите последние 4 цифры"},
                                    minLength: {value: 4, message: "Введите последние 4 цифры"},
                                    validate: (value) =>
                                        isNumeric(value) || "Недопустимые символы",
                                }),
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <CreditCardIcon/>{" "}
                                        <span style={{marginLeft: "4px"}}>#### #### ####</span>
                                    </InputAdornment>
                                ),
                            }}
                            inputProps={{
                                maxLength: 4,
                            }}
                            size="small"
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            name="credit"
                            label="Последние 4 цифры карты, с которой произведена оплата:"
                            type="text"
                            id="credit"
                            style={{marginBottom: "16px", marginTop: 0}}
                        />
                    )}
                    <TextField
                        error={!!errors.reason?.message}
                        helperText={errors.reason?.message ? errors.reason?.message : ""}
                        InputProps={{
                            inputRef: register({
                                required: {value: true, message: "Обязательное поле"},
                                validate: (value) => {
                                    let regexp = /[A-Z]/gi;
                                    if(value.match(regexp) !== null) {
                                        return "Причина возврата содержит недопустимые символы";
                                    }
                                    return true;
                                }
                            })
                        }}
                        inputRef={register()}
                        size="small"
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        name="reason"
                        label="Причина возврата:"
                        type="text"
                        id="reason"
                        autoComplete="reason"
                        multiline
                        rows="3"
                        style={{marginBottom: "16px", marginTop: 0}}
                    />
                </Box>
                <FormControl component="fieldset" style={{marginBottom: "36px"}}>
                    <RadioGroup aria-label="quality" name="quality">
                        <FormControlLabel
                            style={{marginLeft: 0, marginBottom: "8px"}}
                            onChange={() =>
                                setState((prevState) => ({...prevState, radioValue: 1}))
                            }
                            checked={state.radioValue === 1}
                            control={<Radio style={{paddingLeft: 0}} color="primary"/>}
                            label="Товар надлежащего качества, не был в употреблении, сохранены потребительские св-ва и заводская упаковка"
                        />
                        <FormControlLabel
                            style={{marginLeft: 0}}
                            onChange={() =>
                                setState((prevState) => ({...prevState, radioValue: 2}))
                            }
                            checked={state.radioValue === 2}
                            control={<Radio style={{paddingLeft: 0}} color="primary"/>}
                            label="Товар ненадлежащего качества, обнаружен брак, от ремонта отказываюсь"
                        />
                        <FormControlLabel
                            style={{marginLeft: 0}}
                            onChange={() =>
                                setState((prevState) => ({...prevState, radioValue: 3}))
                            }
                            checked={state.radioValue === 3}
                            control={<Radio style={{paddingLeft: 0}} color="primary"/>}
                            label="Товар не получен"
                        />
                        <FormControlLabel
                            style={{marginLeft: 0}}
                            onChange={() =>
                                setState((prevState) => ({...prevState, radioValue: 4}))
                            }
                            checked={state.radioValue === 4}
                            control={<Radio style={{paddingLeft: 0}} color="primary"/>}
                            label="Ошибка магазина, пересорт, неверная информация"
                        />
                        <FormControlLabel
                            style={{marginLeft: 0}}
                            onChange={() =>
                                setState((prevState) => ({...prevState, radioValue: 5}))
                            }
                            checked={state.radioValue === 5}
                            control={<Radio style={{paddingLeft: 0}} color="primary"/>}
                            label="Компенсация"
                        />
                    </RadioGroup>
                </FormControl>
                <div style={{overflow: "auto"}}>
                    <div style={{marginBottom: "36px"}}>
                        <Typography
                            variant="h6"
                            className={classes.title}
                            style={{marginBottom: "16px"}}
                        >
                            Товары
                        </Typography>
                        {custom && (
                            <box>
                            {fields.map((item, index) => (   
                            <box>
                            <TextField
                            error={errors.customItems && !!errors.customItems[index].price?.message}
                            helperText={errors.customItems && errors.customItems[index].price?.message ? errors.customItems[index].price?.message : ""}
                            inputRef={register({
                                required: {value: true, message: "Обязательное поле"},
                            })}
                            size="small"
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            control={control}
                            id={`customItems.${index}.name`}
                            label="Наименование:"
                            name={`customItems.${index}.name`}
                            style={{marginBottom: "16px"}}
                            />
                            <TextField
                            error={errors.customItems && !!errors.customItems[index].qty?.message}
                            helperText={errors.customItems && errors.customItems[index].qty?.message ? errors.customItems[index].qty?.message : ""}
                            inputRef={register({
                                required: {value: true, message: "Обязательное поле"},
                                validate: (value) =>
                                    isNumeric(value) || "Недопустимые символы",
                            })}
                            size="small"
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            control={control}
                            id={`customItems.${index}.qty`}
                            label="Количество:"
                            name={`customItems.${index}.qty`}
                            style={{marginBottom: "16px"}}
                            />
                            <TextField
                            error={errors.customItems && !!errors.customItems[index].price?.message}
                            helperText={errors.customItems && errors.customItems[index].price?.message ? errors.customItems[index].price?.message : ""}
                            inputRef={register({
                                required: {value: true, message: "Обязательное поле"},
                                validate: (value) =>
                                    isNumeric(value) || "Недопустимые символы",
                            })}
                            size="small"
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            control={control}
                            id={`customItems.${index}.price`}
                            label="Цена за единицу:"
                            name={`customItems.${index}.price`}
                            style={{marginBottom: "16px"}}
                            />
                            </box>
                         ))}
                         <Button
                            className={classes.submit}
                            variant="contained"
                            disableElevation
                            onClick={() => append({ name: "" })}
                        >
                            Добавить товар
                        </Button>

                        <DatePicker 
                            inputRef={register()}
                            size="small"
                            name="dateBuy"
                            id="dateBuy"
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            placeholderText="Дата покупки" 
                            label="Дата покупки"
                            selected={dateBuy} 
                            onChange={(date) => setDateBuy(date)}
                            customInput={<TextField
                                inputRef={register()}
                                size="small"
                                variant="outlined"
                                margin="normal"
                                label="Дата покупки"
                                fullWidth
                                style={{marginBottom: "16px"}}
                                />}
                        />
                            </box>
                        )}
                        {items.map((item) => (
                            <Grid
                                key={item.codeItem}
                                container
                                alignContent="center"
                                style={{marginBottom: "24px", flexWrap: "wrap"}}
                            >
                                <Grid item xs={12} md={6} style={{marginBottom: "8px"}}>
                                    <FormControl>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    inputRef={register({
                                                        required: {
                                                            value: true,
                                                            message: "Укажите товары к возврату",
                                                        },
                                                    })}
                                                    onChange={(event) => setProduct(event, item)}
                                                    value={JSON.stringify(item)}
                                                    name="products"
                                                    color="primary"
                                                />
                                            }
                                            label={`${item.codeItem} - ${item.nameItem}`}
                                        />
                                    </FormControl>
                                </Grid>
                                {state.products[item.codeItem] && (
                                    <Grid item xs={12} md={6} style={{paddingLeft: "32px"}}>
                                        <FormControl
                                            variant="outlined"
                                            size="small"
                                            style={{minWidth: "120px"}}
                                        >
                                            <InputLabel>Кол-во</InputLabel>
                                            <Select
                                                label="Кол-во"
                                                value={state.products[item.codeItem].amount || 1}
                                                onChange={(e) =>
                                                    setAmount(e.target.value, item.codeItem)
                                                }
                                            >
                                                {[...Array(item.quantityItem)].map((_, count) => (
                                                    <MenuItem key={count + 1} value={count + 1}>
                                                        {count + 1}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                )}
                            </Grid>
                        ))}
                        {errors.products?.message && (
                            <FormHelperText error>{errors.products?.message}</FormHelperText>
                        )}
                    </div>
                </div>
                <div style={{marginBottom: "36px"}}>
                    <FormControl error={!!errors.policyAcknowledge?.message}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    inputRef={register({
                                        required: {
                                            value: true,
                                            message:
                                                "Необходимо ознакомиться с Политикой обработки персональных данных",
                                        },
                                    })}
                                    name="policyAcknowledge"
                                    color="primary"
                                />
                            }
                            label={
                                <span>
                                    Ознакомлен с{" "}
                                    <a href="https://giper.fm/politic" target="_blank" rel="noopener noreferrer">
                                        Политикой обработки персональных данных
                                    </a>
                                </span>
                            }
                        />
                        <FormHelperText error={!!errors.policyAcknowledge?.message}>
                            {errors.policyAcknowledge?.message}
                        </FormHelperText>
                    </FormControl>
                    <FormControl error={!!errors.policyConsent?.message}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    inputRef={register({
                                        required: {
                                            value: true,
                                            message:
                                                "Необходимо согласие на обработку персональных данных",
                                        },
                                    })}
                                    name="policyConsent"
                                    color="primary"
                                />
                            }
                            label={
                                <span>
                                    Даю{" "}
                                    <a href="https://vozvrat.giper.fm/personal-data-policy" target="_blank" rel="noopener noreferrer">
                                        согласие на обработку своих персональных данных
                                    </a>
                                </span>
                            }
                        />
                        <FormHelperText error={!!errors.policyConsent?.message}>
                            {errors.policyConsent?.message}
                        </FormHelperText>
                    </FormControl>
                </div>
                <Grid container style={{ marginBottom: "20px", fontSize: "25px" }} justify="center" spacing={3}>
                ПРИМИТЕ РЕШЕНИЕ ПО ЗАКАЗУ
                </Grid>
                <Grid container justify="center" spacing={3}>
                    <Grid item>
                        <Button
                            style={{ fontSize: "25px" }}
                            className={classes.submit}
                            variant="contained"
                            disableElevation
                            onClick={handleSubmit(
                                (data) => onSubmit(data, "exchange"),
                                () => setCountSubmit(1)
                            )}
                        >
                            {" "}
                            Обменять товары
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button
                            style={{ fontSize: "25px" }}
                            className={classes.submit}
                            variant="contained"
                            disableElevation
                            onClick={handleSubmit(
                                (data) => onSubmit(data, "refund"),
                                () => setCountSubmit(1)
                            )}
                        >
                            Вернуть деньги
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </Container>
    );
};

export default RefundForm;
